/*
* Country codes
* */
export const COUNTRY_CODE_FOR_SLOVAKIA = '703';
export const COUNTRY_CODE_FOR_UKRAINE = '804';
export const COUNTRY_CODE_FOR_ROMANIA = '642';
export const COUNTRY_CODE_FOR_SERBIA = '688';
export const COUNTRY_CODE_FOR_CZECH_REPUBLIC = '203';
export const COUNTRY_CODE_FOR_RUSSIA = '1004';
export const COUNTRY_CODE_FOR_RUSSIA_FEDERATION = '643';
export const COUNTRY_CODE_FOR_HUNGARY = '348';
export const COUNTRY_CODE_FOR_VIETNAM = '704';

export const MOST_RELEVANT_COUNTRIES = [
  COUNTRY_CODE_FOR_SLOVAKIA,
  COUNTRY_CODE_FOR_UKRAINE,
  COUNTRY_CODE_FOR_ROMANIA,
  COUNTRY_CODE_FOR_SERBIA,
  COUNTRY_CODE_FOR_CZECH_REPUBLIC,
  COUNTRY_CODE_FOR_RUSSIA,
  COUNTRY_CODE_FOR_RUSSIA_FEDERATION,
  COUNTRY_CODE_FOR_HUNGARY,
  COUNTRY_CODE_FOR_VIETNAM,
];

/*
* Areas
* */
export const AREA_EUROPE = 'EU';
export const AREA_CZECH_REPUBLIC = 'CZ';
export const AREA_SLOVAK_REPUBLIC = 'SK';
export const AREA_WORLD = 'SVET';

/*
* App paths
* */
export const SLOVAK_APP_PATH_NAME = 'online-prihlaska-uzp';
export const ENGLISH_APP_PATH_NAME = 'online-registration-uzp';

export const ACCEPT_FILE_FORMATS = `
  image/png, image/jpeg, image/jpg, application/pdf, .csv,
  application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel,
  .doc, .docx
`;

export const MIN_SIZE_OF_ATTACHMENT = 1024; // 1kb

export const MAX_SIZE_OF_ATTACHMENT = 1024 * 1024 * 5; // 5MB

export const MAX_SIZE_OF_ALL_ATTACHMENTS = 1024 * 1024 * 20; // 20MB

export const MAX_ATTACHMENTS = 20;

export const E_SIGNATURE_SUCCESS_RESULTS = ['FINISHED'];
/**
 * Step with document uploads for a person
 * @type {number}
 */
export const DOCUMENT_STEP_ROUTER_NUMBER = 19;
